import { SUPER_ADMIN } from "@/components/data/constants";

// Seeded verbatim per tenant by the backend's roleInitializer, and matched
// exactly there too (PROPOSAL_APPROVER_ROLE_NAME).
export const PROPOSAL_SPECIALIST_ROLE = "Proposal Specialist";

/**
 * Who may see the Proposal AI Prompts screen (SERV-3053): super admins and
 * Proposal Specialists. This only decides what the UI shows; the backend
 * enforces the same rule on every prompt endpoint, including the read.
 */
export function canManageProposalPrompts(
  userRoles: string[] | undefined,
  userType: string | null | undefined,
): boolean {
  if (userType === SUPER_ADMIN) return true;
  return (userRoles ?? []).includes(PROPOSAL_SPECIALIST_ROLE);
}
